if (!customElements.get("mm-collapsible-row")) {
	customElements.define(
		"mm-collapsible-row",
		class MMCollapsibleRow extends HTMLElement {
			constructor() {
				super();
				document.addEventListener("DOMContentLoaded", () => {
					const anchor = window.location.hash;
					if (anchor) {
						const items = document.querySelectorAll(".accordion-item");
						items.forEach((item) => {
							const dataAnchor = item.getAttribute("data-anchor");
							if (dataAnchor === anchor.substring(1)) {
								const summary = item.querySelector(".accordion-details summary");
								if (summary) {
									summary.click(); // Comportement natif accordéon
								}
							}
						});
					}
				});
			}
		}
	);
}
